import { CheckIcon, LanguageIcon } from '@heroicons/react/24/outline';
import { urlFlag } from '../../../common/urlBase';
import { capitalizarPalabras } from '../../../common/upperCaseWord';

/**
 * Filtro de idiomas del calendario: filas tipo chip con bandera y estado seleccionado.
 */
export const LanguageFilter = ({
    languageOptions = [],
    selectedLanguageIds = [],
    onToggleLanguage,
    onClearLanguages,
}) => {
    const selectedSet = new Set(selectedLanguageIds.map(String));

    return (
        <section className="cal-sidebar-panel cal-language-filter" aria-labelledby="cal-language-filter-title">
            <div className="cal-sidebar-panel__header cal-language-filter__header">
                <h3 id="cal-language-filter-title" className="cal-sidebar-panel__title">
                    Idiomas
                </h3>
                {selectedLanguageIds.length > 0 && (
                    <button
                        type="button"
                        onClick={onClearLanguages}
                        className="cal-language-filter__clear"
                    >
                        Limpiar
                    </button>
                )}
            </div>

            {languageOptions.length === 0 ? (
                <p className="cal-language-filter__empty">No hay idiomas por mostrar.</p>
            ) : (
                <ul className="cal-sidebar-panel__list cal-language-filter__list">
                    {languageOptions.map((language) => {
                        const checked = selectedSet.has(String(language.id));
                        const flagUrl = language.path ? `${urlFlag}${language.path}` : null;
                        const inputId = `cal-language-${language.id}`;

                        return (
                            <li key={language.id}>
                                <label
                                    htmlFor={inputId}
                                    className={`cal-sidebar-row cal-language-filter__option${checked ? ' is-selected' : ''}`}
                                >
                                    <input
                                        id={inputId}
                                        type="checkbox"
                                        className="cal-language-filter__input"
                                        checked={checked}
                                        onChange={() => onToggleLanguage(language.id)}
                                    />
                                    <span className="cal-sidebar-row__icon cal-sidebar-row__icon--flag" aria-hidden="true">
                                        {flagUrl ? (
                                            <img
                                                src={flagUrl}
                                                alt=""
                                                className="cal-language-filter__flag"
                                                loading="lazy"
                                                decoding="async"
                                            />
                                        ) : (
                                            <LanguageIcon className="cal-language-filter__flag-fallback" />
                                        )}
                                    </span>
                                    <span className="cal-sidebar-row__label" title={capitalizarPalabras(language.name)}>
                                        {capitalizarPalabras(language.name)}
                                    </span>
                                    <span className="cal-sidebar-row__slot">
                                        <span className={`cal-language-filter__check${checked ? ' is-selected' : ''}`}>
                                            {checked ? (
                                                <CheckIcon className="cal-language-filter__check-icon" />
                                            ) : null}
                                        </span>
                                    </span>
                                </label>
                            </li>
                        );
                    })}
                </ul>
            )}

            <p className="cal-language-filter__hint">
                Sin selección se muestran todos tus cursos.
            </p>
        </section>
    );
};
